module.exports = __webpack_public_path__ + "img/18.40194aea.jpg";